// Approval Type Codes
export const APPROVAL_TYPE_CODES = {
  APPROVED: 'app',
  REJECTED: 'rej',
  SENDBACK: 'sbk',
  COMMITTEE: 'com',
};

// Approval Actions
export const APPROVAL_ACTIONS = {
  [APPROVAL_TYPE_CODES.APPROVED]: 'approved',
  [APPROVAL_TYPE_CODES.REJECTED]: 'rejected',
  [APPROVAL_TYPE_CODES.SENDBACK]: 'sendback',
  [APPROVAL_TYPE_CODES.COMMITTEE]: 'committee'
};

// Helper function to get action by code
export const getApprovalActionByCode = (code) => {
  return APPROVAL_ACTIONS[code] || 'committee';
}; 